import axios from 'axios';
import { API_URL } from '../config';

const BITRIX_API_URL = process.env.REACT_APP_BITRIX_URL || '';

class BitrixAPI_B24 {
  static formatFiles(filesArray) {
    if (!filesArray || !Array.isArray(filesArray)) return [];
    
    return filesArray.map(file => {
      if (!file) return null;
      
      // Проверяем, является ли файл объектом с id и url
      if (typeof file === 'object' && file.id) {
        return {
          id: file.id,
          name: file.name || `Чертеж ${file.id}`,
          url: file.urlMachine || file.url || null
        };
      }
      
      // Если файл передан как простое значение (id)
      return {
        id: file,
        name: `Чертеж ${file}`,
        url: null
      };
    }).filter(file => file !== null); 
  }

  static async getActiveOrderscutting() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '1036',
          'filter[stageId]': 'DT1036_6:UC_58B1IG',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm3_1746789910',    // Деталировка чертежа
            'ufCrm3_1746789890',     // Дизайн чертежа
            'ufCrm_1731834379472',
            'ufCrm_1731834391787'
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrdersdrilling() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_MRC0UB',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrderszakalka() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_OSBBTX',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrdersmatovka() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_O9RWX3',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getCompletedOrders() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_29:NEW',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568',     // Чертежи для производства
            'createdTime',             // Время создания
            'updatedTime'              // Время обновления
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        const createdDate = item.createdTime ? new Date(item.createdTime).toLocaleDateString() : '';
        const updatedDate = item.updatedTime ? new Date(item.updatedTime).toLocaleDateString() : '';

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'completed',
          files: mainFiles,
          productionFiles: prodFiles,
          createdDate,
          completedDate: updatedDate
        };
      });
    } catch (error) {
      console.error('Ошибка при получении готовых заказов:', error);
      throw error;
    }
  }

  static async getActiveOrderssclad() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_29:UC_7DAFQ0',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrderszakup() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_29:CLIENT',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrdersloft() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_0LNTUT',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrdersupak() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_WAYA1A',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568'      // Чертежи для производства
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  // Методы для получения заказов nazak
  static async getNazakOrders() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '147',
          'filter[stageId]': 'DT147_13:UC_IYLP7J',
          'select[]': [
            'id',
            'title',
            'ufCrm7_1726594282808',
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568',     // Чертежи для производства
            'createdTime',             // Время создания
            'updatedTime'              // Время обновления
          ]
        }
      });

      const items = response.data.result.items || [];
      
      return items.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
        const prodFiles = this.formatFiles(item.ufCrm_1665746232568);

        const createdDate = item.createdTime ? new Date(item.createdTime).toLocaleDateString() : '';
        const updatedDate = item.updatedTime ? new Date(item.updatedTime).toLocaleDateString() : '';

        return {
          id: item.id,
          orderNumber: item.ufCrm7_1726594282808 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'nazak',
          files: mainFiles,
          productionFiles: prodFiles,
          createdDate,
          updatedDate
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов nazak:', error);
      throw error;
    }
  }

  // Методы для обновления стадий
  static async updateStagesclad(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStagesclad`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStageloft(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStageloft`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStageupak(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStageupak`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStageToPurchase(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStageToPurchase`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе заказа в закупку:', error);
      throw error;
    }
  }

  static async updateStagecutting(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStage`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStagedrilling(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStagedrilling`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStagezakalka(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStagezakalka`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии закалки:', error);
      throw error;
    }
  }

  static async updateStagematovka(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStagematovka`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии матовки:', error);
      throw error;
    }
  }

  static async updateFromNazakToZakalka(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateFromNazakToZakalka`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе из nazak в закалку:', error);
      throw error;
    }
  }

  static async updateFromZakalkaToNazak(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateFromZakalkaToNazak`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе из закалки в nazak:', error);
      throw error;
    }
  }

  static async createLead(leadData) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/create-lead`, 
        leadData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка создания лида:', error);
      throw error;
    }
  }

  static async createDeal(dealData, files = []) {
    try {
      const token = localStorage.getItem('token');
      
      // Если есть файлы, используем FormData для multipart/form-data
      if (files && files.length > 0) {
        const formData = new FormData();
        
        // Добавляем данные сделки как JSON
        formData.append('dealData', JSON.stringify(dealData));
        
        // Добавляем файлы
        files.forEach(file => {
          formData.append('files', file);
        });

        const response = await axios.post(`${API_URL}/api/create-deal`,
          formData,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        return response.data;
      } else {
        // Обычный JSON запрос без файлов
        const response = await axios.post(`${API_URL}/api/create-deal`, 
          dealData,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        
        return response.data;
      }
    } catch (error) {
      console.error('Ошибка создания сделки:', error);
      throw error;
    }
  }

  // Новый метод для поиска сделок с фильтрами
  static async searchDeals(filters = {}, options = {}) {
    try {
      const {
        page = 1,
        pageSize = 50,
        entityTypeId = '1036',
        select = [
          'id', 'title', 'stageId', 'createdTime', 'updatedTime',
          'assignedById', 'opportunity', 'ufCrm3_1746789101'
        ]
      } = options;

      const params = {
        entityTypeId,
        start: (page - 1) * pageSize,
        limit: pageSize,
        ...filters
      };

      // Добавляем поля для выборки
      select.forEach(field => {
        params[`select[]`] = field;
      });

      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const items = response.data.result?.items || [];
      const hasMore = response.data.more || false;
      const total = response.data.total || items.length;

      // Нормализуем данные
      const normalizedItems = items.map(item => ({
        id: item.id,
        title: item.title || 'Без названия',
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        stageId: item.stageId,
        currentStage: this.getStageNameById(item.stageId),
        createdTime: item.createdTime,
        updatedTime: item.updatedTime,
        assignedById: item.assignedById,
        opportunity: item.opportunity || 0,
        // Добавляем дополнительные поля если они есть
        clientName: item.contactName || item.companyTitle || '',
        responsibleUser: item.assignedByName || '',
        status: this.mapStageToStatus(item.stageId),
        comment: item.comments || ''
      }));

      return {
        items: normalizedItems,
        hasMore,
        total,
        page,
        pageSize
      };
    } catch (error) {
      console.error('Ошибка поиска сделок:', error);
      throw error;
    }
  }

  // Получить все доступные поля для фильтрации
  static async getAvailableFields() {
    try {
      // Делаем тестовый запрос для получения структуры полей
      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          entityTypeId: '1036',
          start: 0,
          limit: 1
        },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      let dynamicFields = [];
      
      if (response.data.result?.items?.[0]) {
        const item = response.data.result.items[0];
        console.log('Поля из тестового запроса к Битрикс:', Object.keys(item));
        
        // Создаем поля на основе реальных данных
        dynamicFields = Object.keys(item).map(key => {
          let fieldName = key;
          let fieldType = 'string';
          
          // Определяем тип поля по значению
          const value = item[key];
          if (key.includes('Time') || key.includes('Date')) {
            fieldType = 'date';
          } else if (key === 'opportunity' || typeof value === 'number') {
            fieldType = 'number';
          } else if (key === 'stageId' || key.includes('Stage')) {
            fieldType = 'select';
          }

          // Переводим названия полей на русский
          switch (key) {
            case 'id': fieldName = 'ID'; break;
            case 'title': fieldName = 'Название'; break;
            case 'stageId': fieldName = 'Стадия'; break;
            case 'createdTime': fieldName = 'Дата создания'; break;
            case 'updatedTime': fieldName = 'Дата обновления'; break;
            case 'assignedById': fieldName = 'Ответственный'; break;
            case 'opportunity': fieldName = 'Сумма'; break;
            case 'currencyId': fieldName = 'Валюта'; break;
            case 'categoryId': fieldName = 'Категория'; break;
            case 'companyId': fieldName = 'Компания'; break;
            case 'contactId': fieldName = 'Контакт'; break;
            case 'sourceId': fieldName = 'Источник'; break;
            case 'ufCrm3_1746789101': fieldName = 'Номер заказа'; break;
            case 'ufCrm3_1746789363': fieldName = 'Тип клиента'; break;
            case 'ufCrm3_1746789446': fieldName = 'Тип стекла'; break;
            case 'ufCrm3_1746789468': fieldName = 'Толщина стекла'; break;
            case 'ufCrm3_1746789474': fieldName = 'Размер стекла'; break;
            case 'ufCrm3_1746789572': fieldName = 'Срочность'; break;
            case 'ufCrm3_1746789589': fieldName = 'Адрес доставки'; break;
            case 'ufCrm3_1746789599': fieldName = 'Телефон клиента'; break;
            case 'ufCrm3_1746789627': fieldName = 'Особые указания'; break;
            default: 
              if (key.startsWith('uf')) {
                fieldName = `Поле ${key}`;
              }
              break;
          }

          return {
            id: key,
            name: fieldName,
            type: fieldType,
            field: key
          };
        }).filter(field => 
          // Исключаем системные поля
          !['createdBy', 'updatedBy', 'movedBy', 'lastActivityTime', 'lastActivityBy'].includes(field.id)
        );
      }

      // Объединяем с базовыми полями если динамические не загрузились
      const baseFields = [
        { id: 'id', name: 'ID', type: 'number', field: 'id' },
        { id: 'title', name: 'Название', type: 'string', field: 'title' },
        { id: 'ufCrm3_1746789101', name: 'Номер заказа', type: 'string', field: 'ufCrm3_1746789101' },
        { id: 'stageId', name: 'Стадия', type: 'select', field: 'stageId', options: [
          { value: 'DT1036_6:NEW', label: 'Новая заявка' },
          { value: 'DT1036_6:UC_58B1IG', label: 'Резка стекла' },
          { value: 'DT1036_6:UC_HD3BPN', label: 'Обработка стекла' },
          { value: 'DT1036_6:UC_PBEINX', label: 'На закалке' },
          { value: 'DT1036_6:UC_4FXLEO', label: 'Матировка' },
          { value: 'DT1036_6:UC_WE1KJE', label: 'Сборка лофта' },
          { value: 'DT1036_6:UC_SNLWF9', label: 'Упаковка' },
          { value: 'DT1036_6:UC_ZZP9IY', label: 'Комплектация' },
          { value: 'DT1036_6:SUCCESS', label: 'Выполнен' }
        ]},
        { id: 'createdTime', name: 'Дата создания', type: 'date', field: 'createdTime' },
        { id: 'updatedTime', name: 'Дата обновления', type: 'date', field: 'updatedTime' },
        { id: 'assignedById', name: 'Ответственный', type: 'string', field: 'assignedById' },
        { id: 'opportunity', name: 'Сумма', type: 'number', field: 'opportunity' },
        { id: 'ufCrm3_1746789363', name: 'Тип клиента', type: 'string', field: 'ufCrm3_1746789363' },
        { id: 'ufCrm3_1746789446', name: 'Тип стекла', type: 'string', field: 'ufCrm3_1746789446' },
        { id: 'ufCrm3_1746789468', name: 'Толщина стекла', type: 'string', field: 'ufCrm3_1746789468' },
        { id: 'ufCrm3_1746789474', name: 'Размер стекла', type: 'string', field: 'ufCrm3_1746789474' },
        { id: 'ufCrm3_1746789572', name: 'Срочность', type: 'string', field: 'ufCrm3_1746789572' },
        { id: 'ufCrm3_1746789589', name: 'Адрес доставки', type: 'string', field: 'ufCrm3_1746789589' },
        { id: 'ufCrm3_1746789599', name: 'Телефон клиента', type: 'string', field: 'ufCrm3_1746789599' },
        { id: 'ufCrm3_1746789627', name: 'Особые указания', type: 'string', field: 'ufCrm3_1746789627' }
      ];

      return dynamicFields.length > 0 ? dynamicFields : baseFields;
    } catch (error) {
      console.error('Ошибка получения полей:', error);
      
      // Fallback к статическим полям
      return [
        { id: 'id', name: 'ID', type: 'number', field: 'id' },
        { id: 'title', name: 'Название', type: 'string', field: 'title' },
        { id: 'ufCrm3_1746789101', name: 'Номер заказа', type: 'string', field: 'ufCrm3_1746789101' },
        { id: 'stageId', name: 'Стадия', type: 'select', field: 'stageId' },
        { id: 'createdTime', name: 'Дата создания', type: 'date', field: 'createdTime' },
        { id: 'updatedTime', name: 'Дата обновления', type: 'date', field: 'updatedTime' },
        { id: 'assignedById', name: 'Ответственный', type: 'string', field: 'assignedById' },
        { id: 'opportunity', name: 'Сумма', type: 'number', field: 'opportunity' }
      ];
    }
  }

  // Получить название стадии по ID
  static getStageNameById(stageId) {
    const stages = {
      'DT1036_6:NEW': 'Новая заявка',
      'DT1036_6:UC_58B1IG': 'Резка стекла',
      'DT1036_6:UC_HD3BPN': 'Обработка стекла',
      'DT1036_6:UC_0JY06B': 'Арм 1',
      'DT1036_6:UC_TACW0R': 'Готово К закалке',
      'DT1036_6:UC_PBEINX': 'На закалке',
      'DT1036_6:UC_RN2FGC': 'Арм 2',
      'DT1036_6:UC_4FXLEO': 'Матировка',
      'DT1036_6:UC_5GKJLH': 'Арм 3',
      'DT1036_6:UC_WE1KJE': 'Сборка лофта / Зеркала',
      'DT1036_6:UC_EVJQPD': 'Арм 4',
      'DT1036_6:UC_SNLWF9': 'Упаковка',
      'DT1036_6:UC_NNZ8TM': 'Арм 5',
      'DT1036_6:UC_ZZP9IY': 'Комплектация',
      'DT1036_6:SUCCESS': 'Выполнен',
      'DT1036_6:FAIL': 'Провал'
    };
    return stages[stageId] || 'Неизвестная стадия';
  }

  // Сопоставить стадию со статусом
  static mapStageToStatus(stageId) {
    if (!stageId) return 'new';
    
    if (stageId.includes('SUCCESS')) return 'completed';
    if (stageId.includes('FAIL')) return 'cancelled';
    if (stageId.includes('NEW')) return 'new';
    
    return 'in_progress';
  }
}

export default BitrixAPI_B24;
